module.exports = __webpack_public_path__ + "img/sy03.7b69f18d.svg";